import React, { useState } from 'react';
import { Control, Controller } from "react-hook-form";
import {IconButton, InputAdornment, StandardTextFieldProps, TextField} from "@mui/material";
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

export interface ControlledTextPasswordFieldProps extends StandardTextFieldProps {
    control: Control<any>
}

export function ControlledPasswordField(props: ControlledTextPasswordFieldProps) {

    const [showPassword, setShowPassword] = useState<boolean>(false);

    const handleClickShowPassword = () => setShowPassword(!showPassword);

    return (
        <Controller
            control={props.control}
            name={props.name || ''}
            render={({field: {onChange, value}, fieldState: {error}}) => (
                <TextField
                    {...props}
                    variant="outlined"
                    size="small"
                    type={showPassword ? 'text' : 'password'}
                    value={value}
                    onChange={onChange}
                    error={!!error}
                    defaultValue={props.defaultValue}
                    helperText={error ? error.message : null}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton
                                    onClick={handleClickShowPassword}
                                    edge="end" >
                                    { showPassword ? <VisibilityOffIcon /> : <VisibilityIcon /> }
                                </IconButton>
                            </InputAdornment>
                        ),
                        ...props.InputProps
                    }}
                    InputLabelProps={{
                        shrink: value+1,
                        ...props.InputLabelProps,
                    }}
                >
                </TextField>
            )}
        />
    );
};
